// Course tag modal ("Edit tags" on the course Tags page). A tag typed under
// "Create tags" is filed under "Manage tags" as soon as Enter or comma is
// pressed, so authors never have to click the "+" on the chip first.

const TAG_COLOURS = [
  ["country", "47, 156, 152"],
  ["office", "65, 117, 5"],
  ["role", "133, 46, 151"],
]

const ENTER_KEY = 13

// Labels are configurable, so fall back to the country colour like get_tag_border_class does.
const rgbFor = (tagLabel) => (TAG_COLOURS.find(([key]) => tagLabel.includes(key)) || TAG_COLOURS[0])[1]

export const initCourseTagsModal = (tagLabel) => {
  const $ = window.jQuery
  const modal = $(`#${tagLabel}`)
  const createList = modal.find(`#tag_${tagLabel}`)
  const manageList = modal.find(".course-manage-tags")
  const assignedField = modal.find("#course_tags")
  const rgb = rgbFor(tagLabel)

  const assignedTags = () =>
    assignedField
      .val()
      .split(",")
      .filter((tag) => tag !== "")

  const isAssigned = (label) => assignedTags().some((tag) => tag.toLowerCase() === label.toLowerCase())

  const paint = (scope) => {
    scope.find(".tag-label").css("background", `rgba(${rgb}, 0.8)`)
    scope.find(".tag-close").css("background", `rgb(${rgb})`)
  }

  const addToManageList = (label) => {
    const pill = $("<li></li>")
      .addClass("tags-custom-box")
      .append($("<span></span>").addClass("tag-label").text(label))
      .append($("<span></span>").addClass("tag-close").text("x"))

    manageList.append(pill)
    paint(pill)
    assignedField.val(assignedTags().concat(label).join(","))
  }

  const tagInput = () => createList.find("li.tagit-new input")

  createList.tagit({
    singleField: true,
    allowSpaces: true,
    beforeTagAdded: (event, ui) => {
      // The tag is already under "Manage tags", so adding it again would duplicate it.
      if (isAssigned(ui.tagLabel)) return false
    },
    afterTagAdded: (event, ui) => {
      if (ui.duringInitialization) return
      addToManageList(ui.tagLabel)
      createList.tagit("removeTag", ui.tag, false)
    },
  })

  paint(manageList)

  // tag-it only swallows Enter while the field has text; an empty field would submit the form.
  createList.off("keydown.courseTags").on("keydown.courseTags", "input", (event) => {
    if (event.which === ENTER_KEY) event.preventDefault()
  })

  modal.off("click.courseTags").on("click.courseTags", ".course-manage-tags .tags-custom-box", function () {
    const pill = $(this)
    const label = pill.find(".tag-label").text()

    assignedField.val(
      assignedTags()
        .filter((tag) => tag !== label)
        .join(","),
    )
    pill.remove()
  })

  // Saving with text still in the field should keep that tag rather than drop it.
  modal.off("submit.courseTags").on("submit.courseTags", "form", () => {
    const pending = tagInput().val() || ""

    pending.split(",").forEach((label) => createList.tagit("createTag", label))
    tagInput().val("")
  })

  modal.find(".modal-close").on("click", () => modal.closeModal())
}

window.initCourseTagsModal = initCourseTagsModal
